export enum OsType {
  Ios = 1,
  Android = 2,
  Web = 3,
}

